// @flow
import { LOGOUT, STORE_ERROR, REQUEST_LOGIN, REGISTER_ACCOUNT, OPEN_LOGIN_MODAL, OPEN_SIGNUP_MODAL, CLOSE_LOGIN_MODAL, CLEAR_ALL_ERRORS, INIT_USER_INFO, STORE_TOKEN } from './types';
export var openLoginModal = function openLoginModal() {
  return {
    type: OPEN_LOGIN_MODAL
  };
};
export var openSignUpModal = function openSignUpModal() {
  return {
    type: OPEN_SIGNUP_MODAL
  };
};
export var closeAuthModal = function closeAuthModal() {
  return {
    type: CLOSE_LOGIN_MODAL
  };
};
export var requestLogin = function requestLogin(credentials) {
  return {
    type: REQUEST_LOGIN,
    credentials: credentials
  };
};
export var registerAccount = function registerAccount(credentials) {
  return {
    type: REGISTER_ACCOUNT,
    credentials: credentials
  };
};
export var reportError = function reportError(error) {
  return {
    type: STORE_ERROR,
    error: error
  };
};
export var clearError = function clearError() {
  return {
    type: CLEAR_ALL_ERRORS
  };
};
export var logout = function logout() {
  return {
    type: LOGOUT
  };
};
export var storeToken = function storeToken(token, userRole, id) {
  return {
    type: STORE_TOKEN,
    token: token,
    userRole: userRole,
    id: id
  };
};
export var initUserInfo = function initUserInfo() {
  return {
    type: INIT_USER_INFO
  };
};